import { render, staticRenderFns } from "./MovementProducts.vue?vue&type=template&id=5c035092&scoped=true&"
import script from "./MovementProducts.vue?vue&type=script&lang=js&"
export * from "./MovementProducts.vue?vue&type=script&lang=js&"
import style0 from "./MovementProducts.vue?vue&type=style&index=0&id=5c035092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c035092",
  null
  
)

export default component.exports